import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import franceFlag from "../assets/img/flag-france.jpg";
import ukFlag from "../assets/img/flag-en.jpg";
import "../assets/css/main.css";
import "../assets/vendor/bootstrap/css/bootstrap.min.css";
import "../assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "../assets/vendor/aos/aos.css";
import "../assets/vendor/glightbox/css/glightbox.min.css";
import "../assets/vendor/swiper/swiper-bundle.min.css";

function Header({ changeLanguage, language }) {
  const [mobileNavActive, setMobileNavActive] = useState(false);
  const { t } = useTranslation();

  const toggleMobileNav = () => {
    setMobileNavActive(!mobileNavActive);
  };

  const closeMobileNav = () => {
    setMobileNavActive(false);
  };

  // Ferme le menu si on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      const navMenu = document.getElementById("new-mobile-nav");
      const navToggle = document.querySelector(".new-mobile-nav-toggle");
      
      if (navMenu && !navMenu.contains(event.target) && navToggle !== event.target) {
        setMobileNavActive(false);
      }
    };

    if (mobileNavActive) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => document.removeEventListener("click", handleClickOutside);
  }, [mobileNavActive]);

  return (
    <header id="header" className="header d-flex align-items-center sticky-top">
      <div className="container-fluid container-xl position-relative d-flex align-items-center justify-content-between">
        
        {/* Logo */}
        <a href="#hero" className="logo d-flex align-items-center">
          <h1 className="sitename">Hovig Abechian</h1>
        </a>

        {/* Bouton du menu mobile */}
        <i className="new-mobile-nav-toggle bi bi-list d-xl-none" onClick={toggleMobileNav}></i>

        {/* Menu Desktop */}
        <nav id="navmenu" className="navmenu">
          <ul>
            <li><a href="#about2" className="nav-link">{t("about")}</a></li>
            <li><a href="#services" className="nav-link">{t("services")}</a></li>
            <li><a href="#Resume2" className="nav-link">{t("experience")}</a></li>
            <li><a href="#contact" className="nav-link">{t("contact")}</a></li>
          </ul>
        </nav>

        {/* Nouveau menu mobile */}
        <nav id="new-mobile-nav" className={`new-mobile-nav ${mobileNavActive ? "active" : ""}`}>
          <ul>
            <li><a href="#about2" className="nav-link" onClick={closeMobileNav}>{t("about")}</a></li>
            <li><a href="#services" className="nav-link" onClick={closeMobileNav}>{t("services")}</a></li>
            <li><a href="#Resume2" className="nav-link" onClick={closeMobileNav}>{t("experience")}</a></li>
            <li><a href="#contact" className="nav-link" onClick={closeMobileNav}>{t("contact")}</a></li>
          </ul>
        </nav>

        {/* Sélecteur de langue */}
        <div className="language-switcher d-flex align-items-center">
          <img
            src={franceFlag}
            alt="Changer la langue en français"
            onClick={() => changeLanguage("fr")}
            style={{
              width: "30px",
              cursor: "pointer",
              marginRight: "10px",
              opacity: language === "fr" ? 1 : 0.5,
              transition: "opacity 0.3s",
            }}
          />
          <img
            src={ukFlag}
            alt="Switch language to English"
            onClick={() => changeLanguage("en")}
            style={{
              width: "30px",
              cursor: "pointer",
              opacity: language === "en" ? 1 : 0.5,
              transition: "opacity 0.3s",
            }}
          />
        </div>

      </div>
    </header>
  );
}

export default Header;
